class NMPAccordion extends HTMLElement {
  constructor() {
    super();

    if (this.classList.contains('active')) {
      const content = this.lastElementChild;
      content.style.maxHeight = content.scrollHeight + "px";
    }

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const toggleFlag = this.classList.contains('active');
      
      this.classList.toggle('active');
      const content = this.lastElementChild;

      if (toggleFlag) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }
}

customElements.define('nmp-accordion', NMPAccordion);